import type { FormEvent } from "react";

import { ForgotPasswordPage } from "@repo/ui";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { AccountController } from "../../api/accountController";
import { useAuthSettings } from "./hooks";

export function TLPCloudForgotPasswordPage() {
	const [username, setUserName] = useState<string>("");
	const [disabled, setDisabled] = useState<boolean>(false);
	const [error, setError] = useState<string>("");
	const [loggingIn, setLoggingIn] = useState<boolean>(false);
	const history = useHistory();
	const authSettingsQuery = useAuthSettings();

	useEffect(() => {
		document.title = "TLP Cloud - Forgot Password";
	}, []);

	async function submit(event: FormEvent<HTMLFormElement>) {
		event.preventDefault();
		if (!username) return;
		setDisabled(true);
		setLoggingIn(true);
		await login();
		setDisabled(false);
		setLoggingIn(false);
	}

	async function login() {
		const response = await AccountController.forgotPassword(username);

		if (!response.success) {
			setError(response.message ?? "Something went wrong");
			return;
		} else {
			history.goBack();
		}
	}

	return (
		<ForgotPasswordPage
			username={username}
			setUsername={setUserName}
			submitFunction={submit}
			disabled={disabled}
			loading={loggingIn}
			error={error}
			goBack={() => history.goBack()}
			backgroundImage={authSettingsQuery.data?.backgroundImage}
			appLogo={authSettingsQuery.data?.companyLogo}
		/>
	);
}
